import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import noop from "lodash/noop";
import { createContext, memo, useCallback, useContext, useMemo, useRef, useState } from "react";
const DefaultValue = {
    isFullscreen: false,
    setIsFullscreen: noop,
    fullscreenContainerRef: null,
    setFullscreenContainerRef: noop,
    toggleFullscreen: noop,
    setToggleFullscreen: noop
};
export const FullscreenContext = /*#__PURE__*/ createContext(DefaultValue);
export const FullscreenContextProvider = /*#__PURE__*/ memo((param)=>{
    let { children } = param;
    const [_isFullscreen, changeIsFullscreen] = useState(false);
    const fullscreenContainerRef = useRef(null);
    const toggleFullscreenRef = useRef(noop);
    const setIsFullscreen = useCallback((isFullscreen)=>{
        changeIsFullscreen(isFullscreen);
    }, []);
    const setFullscreenContainerRef = useCallback((ref)=>{
        fullscreenContainerRef.current = ref;
    }, []);
    const setToggleFullscreen = useCallback((toggleFn)=>{
        toggleFullscreenRef.current = toggleFn;
    }, []);
    const toggleFullscreen = useCallback(()=>{
        toggleFullscreenRef.current();
    }, []);
    const values = useMemo(()=>{
        return {
            isFullscreen: _isFullscreen,
            setIsFullscreen,
            fullscreenContainerRef: fullscreenContainerRef.current,
            setFullscreenContainerRef,
            toggleFullscreen,
            setToggleFullscreen
        };
    }, [
        _isFullscreen,
        setIsFullscreen,
        setFullscreenContainerRef,
        toggleFullscreen,
        setToggleFullscreen
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(FullscreenContext.Provider, {
            value: values,
            children: children
        })
    });
});
FullscreenContextProvider.displayName = "FullscreenContextProvider";
export const useFullscreenContext = ()=>{
    const values = useContext(FullscreenContext);
    if (values === DefaultValue) {
        console.error("FullscreenContext used outside of FullscreenContextProvider");
    }
    return values;
};
